import {RFValue} from 'react-native-responsive-fontsize';
import TextInputMask from 'react-native-text-input-mask';
import Feather from 'react-native-vector-icons/Feather';
import styled from 'styled-components/native';

export const Container = styled.View`
  flex-direction: row;
  justify-content: space-between;
  height: ${RFValue(35)}px;
`;

export const InputContainer = styled.View`
  height: ${RFValue(35)}px;
  flex: 1;
  padding: 0 24px;

  border-radius: ${RFValue(35)}px;
  flex-direction: row;
  justify-content: space-between;

  align-items: center;
  background: ${({theme}) => theme.colors.input_search};
`;

//@ts-ignore
export const Input = styled(TextInputMask)`
  height: ${RFValue(35)}px;
  border-radius: ${RFValue(35)}px;
  font-family: ${({theme}) => theme.fonts.regular};
  color: ${({theme}) => theme.colors.text_dark};
  font-size: ${RFValue(12)}px;
  flex: 1;
`;

export const CloseButton = styled.TouchableOpacity``;

export const ButtonContainer = styled.View`
  margin-left: ${RFValue(6)}px;
`;

export const Icon = styled(Feather)`
  font-size: ${RFValue(18)}px;
  color: ${({theme}) => theme.colors.text};
`;
